import { Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ShareModalIcon } from "../material/ShareModalIcon";
import { Email, WhatsApp } from "@mui/icons-material";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { useShareModalTexts } from "../../../../hooks/global/useShareModalTexts";
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import React, { useEffect, useState } from "react";
import { useShareContext } from "../../../training-plan/material/listingTopSection/trainingShare";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";

type ShareModalProps = React.ComponentProps<"div">;

export const ShareModal = ({ className }: ShareModalProps) => {
  const theme = useSelector((state: RootState) => state.theme);
  const texts = useShareModalTexts();
  const [url, setUrl] = useState<string>(null);
  const [showCopiedText, setShowCopiedText] = useState(false);
  const { dispatch } = useShareContext();

  function copyLink() {
    setShowCopiedText(true);
    void navigator.clipboard.writeText(window?.location.href);
    setTimeout(() => {
      setShowCopiedText(false);
    }, 2000);
  }

  useEffect(() => {
    if (typeof window.location.href !== "undefined") {
      setUrl(window.location.href);
    }
  }, []);

  const handleCloseModals = () => {
    dispatch({ modal: [] });
  };

  return (
    <ClickAwayListener onClickAway={handleCloseModals}>
      <div
        onClick={(ev) => {
          ev.stopPropagation();
        }}
        style={{
          backgroundImage: "none",
          backgroundColor: theme.componentColors.surface.surfcontainerLow,
        }}
        id="share-modal"
        className={`rounded-2xl p-[24px] space-y-[28px] z-50 ${
          className ? className : ""
        }`}
      >
        <div className="flex flex-col items-start">
          <Typography
            className="text-[24px]"
            sx={{
              color: theme.componentColors.surface.onSurface,
            }}
          >
            {texts.componentTitle}
          </Typography>
          <Typography
            className="text-[14px]"
            sx={{
              color: theme.componentColors.surface.onSurface,
            }}
          >
            {texts.componentDescription}
          </Typography>
        </div>
        <div className="flex w-full justify-between">
          <TwitterShareButton
            url={url}
            title={texts.messageTitle + " | " + texts.messageDescription}
            hashtags={["Pod1um"]}
            related={["Pod1um_APP"]}
          >
            <ShareModalIcon
              Icon={FaXTwitter}
              bgColor="rgba(29, 161, 242, 0.10)"
              textColor="#1DA1F2"
              name="Twitter"
            />
          </TwitterShareButton>

          <FacebookShareButton
            url={url}
            title={texts.messageTitle + " | " + texts.messageDescription}
            hashtag={"Pod1um"}
          >
            <ShareModalIcon
              Icon={FaFacebookF}
              bgColor="rgba(24, 119, 242, 0.10)"
              textColor="#1877F2"
              name="Facebook"
            />
          </FacebookShareButton>

          <EmailShareButton
            url={url}
            title={texts.messageTitle}
            about={texts.messageDescription}
          >
            <ShareModalIcon
              Icon={Email}
              bgColor="rgba(255, 255, 255, 0.10)"
              textColor="#FFF"
              name="Email"
            />
          </EmailShareButton>

          <WhatsappShareButton
            url={url}
            title={texts.messageTitle + " | " + texts.messageDescription}
          >
            <ShareModalIcon
              Icon={WhatsApp}
              bgColor="rgba(37, 211, 102, 0.10)    "
              textColor="#25D366"
              name="WhatsApp"
            />
          </WhatsappShareButton>
        </div>

        <div className="flex justify-end space-x-[8px] items-center">
          {showCopiedText && (
            <Typography
              sx={{
                color: theme.componentColors.surface.onSurface,
              }}
              className="text-[12px] whitespace-nowrap "
            >
              Copied to your clipboard
            </Typography>
          )}
          <Button
            onClick={() => handleCloseModals()}
            className="rounded-3xl px-[8px] py-[10px] whitespace-nowrap"
            sx={{
              textTransform: "none",
              color: theme.componentColors.primary.primary,
            }}
            variant="text"
          >
            Dismiss
          </Button>

          <Button
            variant="text"
            onClick={() => copyLink()}
            className="rounded-3xl px-[8px] py-[10px] whitespace-nowrap"
            sx={{
              textTransform: "none",
              color: theme.componentColors.primary.primary,
            }}
          >
            Copy link
          </Button>
        </div>
      </div>
    </ClickAwayListener>
  );
};
